/* import __COLOCATED_TEMPLATE__ from './standard-modal-header.hbs.js'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'header',
  classNames: ['modal-layout__header'],
  classNameBindings: ['helpText:modal-layout__header--with-helptext'],
  title: null,
  helpText: null
});